export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">关于飞飞漫画网</h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto">
            飞飞漫画网创立于2018年，是国内领先的漫画全集在线看平台。六年来，我们始终坚持免费漫画全集的初心，
            致力于为每一位漫画爱好者提供最全面、最便捷的漫画阅读服务。
          </p>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto mt-4">
            从日漫经典到国漫新秀，从完结神作到连载追更，飞飞漫画网收录超过5万部漫画作品，涵盖热血、恋爱、悬疑、搞笑、奇幻等全部类型。
            我们的团队每日同步更新热门连载，持续扩充完结漫画大全，不断完善漫画全集下载与在线阅读体验。
            感谢每一位读者六年来的支持与陪伴，漫画追更之路，飞飞漫画网与你同行。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-8">
            <div className="text-center">
              <span className="block font-heading font-bold text-2xl md:text-3xl text-primary-600">6年</span>
              <span className="text-xs md:text-sm text-foreground-500">稳定运营</span>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="text-center">
              <span className="block font-heading font-bold text-2xl md:text-3xl text-accent-600">500万+</span>
              <span className="text-xs md:text-sm text-foreground-500">月活读者</span>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="text-center">
              <span className="block font-heading font-bold text-2xl md:text-3xl text-primary-600">5万+</span>
              <span className="text-xs md:text-sm text-foreground-500">漫画资源</span>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="text-center">
              <span className="block font-heading font-bold text-2xl md:text-3xl text-accent-600">100万+</span>
              <span className="text-xs md:text-sm text-foreground-500">日活用户</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}